/**
 * Disclaimer — the config-governed, bilingual NON-CLINICAL disclaimer that the server returns on every
 * answer (AAS-0 governance). Always shown alongside an assistant turn so the operational-only posture
 * is never lost. Plain note styling (info tint), glyph + label + text (never color-only).
 *
 * The text comes verbatim from the server (`answer.disclaimer`) — we never invent or localize it; the
 * server already returns the bilingual string. We render it with `white-space: pre-line` so the
 * server's FR\nAR layout is preserved.
 */
import { useT } from "@/app";

export interface DisclaimerProps {
  text: string;
}

export function Disclaimer({ text }: DisclaimerProps) {
  const { t } = useT();
  if (!text?.trim()) return null;
  return (
    <div
      role="note"
      style={{
        display: "flex",
        gap: "var(--nv-s-2)",
        alignItems: "flex-start",
        padding: "var(--nv-s-2) var(--nv-s-3)",
        borderRadius: "var(--nv-r-sm)",
        background: "var(--nv-azure-soft)",
        border: "1px solid var(--nv-line-faint)",
        fontSize: "var(--nv-fs-caption)",
        color: "var(--nv-slate)",
      }}
    >
      <span aria-hidden style={{ color: "var(--nv-info)" }}>
        ⓘ
      </span>
      <span style={{ whiteSpace: "pre-line" }}>
        <span className="nv-sr-only">{t("ai.disclaimer.label")}: </span>
        {text}
      </span>
    </div>
  );
}
